import { Apartment, PointOfSale } from "@mui/icons-material";
import { InputAdornment, MenuItem, TextField } from "@mui/material";
import { GetData } from "contexts/DataContext";
import { isIdentical, isObjectEmpty } from "data/functions";
import React, { useState } from "react";
import { useEffect } from "react";

export default function EquipmentField(props) {
  const { dataObj, forceSetDataObj } = GetData();
  const [value, setValue] = useState("");

  useEffect(() => {
    let newVal =
      !isObjectEmpty(dataObj?.equipments) && dataObj?.usedEquipment?.name
        ? dataObj?.usedEquipment?.name
        : "";
    if (!isIdentical(value, newVal)) {
      setValue(
        !isObjectEmpty(dataObj?.equipments) && dataObj?.usedEquipment?.name
          ? dataObj?.usedEquipment?.name
          : ""
      );
    }
  }, [dataObj?.usedEquipment, dataObj?.equipments]);

  if (dataObj?.payType === "self-service") {
    return;
  }
  return (
    <TextField
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <PointOfSale />
          </InputAdornment>
        ),
        style: {
          fontSize: dataObj?.deviceWidth?.isMobile ? "0.875rem" : "1rem",
        },
      }}
      error={props?.error}
      fullWidth
      helperText={props?.error ? "Выберите оборудование" : ""}
      label="Оборудование"
      mb={2}
      mt={2}
      name="department"
      // defaultValue=""
      select
      sx={{
        margin: "0.3rem 0",
        minWidth: dataObj?.deviceWidth?.isMobile ? "inherit" : "30%",
      }}
      type="text"
      value={value}
      variant="standard"
    >
      {!isObjectEmpty(dataObj?.equipments) &&
        dataObj?.equipments?.map((item, index) => {
          return (
            <MenuItem
              key={index}
              onClick={(e) => forceSetDataObj(item, "usedEquipment")}
              value={item.name}
            >
              {item.name}
            </MenuItem>
          );
        })}
      {isObjectEmpty(dataObj?.equipments) && (
        <MenuItem>Нет доступного оборудования</MenuItem>
      )}
    </TextField>
  );
}
